<template>
  <svg
    class="animate-spin animate-fast"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 50"
    :style="{height: size, width: size}"
  >
      <path
        fill="currentColor"
        d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"
      ></path>
  </svg>
</template>

<script>
export default {
  name: 'SvgLoader',

  props: {
    size: {
      default: '1.9em',
      type: String,
    },
  },
}
</script>
